import axios, { AxiosError, type AxiosInstance } from 'axios';
import { resolveLanUrl } from './resolveLanUrl';
import { getRuntimeEnv } from './runtimeConfig';

/**
 * Single axios instance for all backend / 3rd-party calls.
 *
 * Reads the base URL from `REACT_APP_API_BASE_URL`. When the future PartnerOS
 * backend lands, point this env at it and any feature using `apiClient` keeps
 * working with no further changes.
 */

const baseURL = resolveLanUrl(getRuntimeEnv('REACT_APP_API_BASE_URL') ?? '');

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

apiClient.interceptors.response.use(
  (res) => res,
  (error: AxiosError) => {
    // Single point to plug in: toast, Sentry, analytics, token refresh, etc.
    // eslint-disable-next-line no-console
    console.error('[HAAT CourierConnect] api error', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.message,
    });
    return Promise.reject(error);
  },
);
